var SessionType;
(function (SessionType) {
    SessionType["READ_ONLY"] = "SESSION_TYPE_READ_ONLY";
    SessionType["READ_WRITE"] = "SESSION_TYPE_READ_WRITE";
})(SessionType || (SessionType = {}));
var FiatOnRampProvider;
(function (FiatOnRampProvider) {
    FiatOnRampProvider["COINBASE"] = "FIAT_ON_RAMP_PROVIDER_COINBASE";
    FiatOnRampProvider["MOONPAY"] = "FIAT_ON_RAMP_PROVIDER_MOONPAY";
})(FiatOnRampProvider || (FiatOnRampProvider = {}));
var FiatOnRampCryptoCurrency;
(function (FiatOnRampCryptoCurrency) {
    FiatOnRampCryptoCurrency["BITCOIN"] = "FIAT_ON_RAMP_CRYPTO_CURRENCY_BTC";
    FiatOnRampCryptoCurrency["ETHEREUM"] = "FIAT_ON_RAMP_CRYPTO_CURRENCY_ETH";
    FiatOnRampCryptoCurrency["SOLANA"] = "FIAT_ON_RAMP_CRYPTO_CURRENCY_SOL";
    FiatOnRampCryptoCurrency["USDC"] = "FIAT_ON_RAMP_CRYPTO_CURRENCY_USDC";
})(FiatOnRampCryptoCurrency || (FiatOnRampCryptoCurrency = {}));

export { FiatOnRampCryptoCurrency, FiatOnRampProvider, SessionType };
//# sourceMappingURL=index.mjs.map
